import { Box, Container, Grid, useMediaQuery, useTheme } from '@mui/material';
import { motion } from 'framer-motion';
import { useInView } from 'react-intersection-observer';
import React, { useEffect, useState } from 'react';
import portfolioData from '../../db.json';
import { Link } from 'react-router-dom';

const OurPortfolio = () => {
  const theme = useTheme();
  const matches = useMediaQuery(theme.breakpoints.down('sm'));
  const [activeItem, setActiveItem] = useState('All Portfolio');

  const menuItems = [
    'All Portfolio',
    'Digital vCard',
    'E-commerce',
    'B2B Listing',
    'Booking Service',
    'Blog & News',
    'LMS System',
    'NGO',
    'SaaS Based',
  ];

  const activeItemData = (() => {
    switch (activeItem) {
      case 'All Portfolio':
        return [
          ...(portfolioData.mobilePortfolio || []),
          ...(portfolioData.WebPortfolio || []),
          ...(portfolioData.blockchainPortfolio || []),
          ...(portfolioData.metaversePortfolio || []),
        ];
      case 'Digital vCard':
        return portfolioData.mobilePortfolio;
      case 'E-commerce':
        return portfolioData.WebPortfolio;
      case 'B2B Listing':
        return portfolioData.blockchainPortfolio;
      case 'Booking Service':
        return portfolioData.metaversePortfolio;
      default:
        return [];
    }
  })();

  return (
    <>
      <style>
        {`.scrollable-menu {
          scrollbar-width: thin;
          overflow-x: auto;
        }

        .scrollable-menu::-webkit-scrollbar {
          height: 8px; /* Adjust scrollbar height */
        }

        .scrollable-menu::-webkit-scrollbar-thumb {
          background: #888; /* Scrollbar color */
          border-radius: 4px; /* Rounded corners */
        }

        .scrollable-menu::-webkit-scrollbar-thumb:hover {
          background: #555; /* Scrollbar color on hover */
        }
        `}
      </style>
      <Box mt={5} id="portfolio">
        <motion.h1
          style={{
            textAlign: 'center',
            fontWeight: 'bold',
            fontSize: 35,
            marginBottom: '30px',
          }}
          initial={{ opacity: 0, y: -50 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 1 }}
        >
          Our Portfolio
        </motion.h1>
        <Container>
          <motion.div
            style={{
              display: 'flex',
              justifyContent: 'flex-start', // Align items to the start
              alignItems: 'center',
              overflowX: 'auto', // Always enable horizontal scrolling
              whiteSpace: 'nowrap', // Keep items in a single row
              maxWidth: '100%', // Prevent overflow beyond container
              paddingBottom: '10px', // Space for scrollbar visibility
            }}
            className="scrollable-menu"
            initial={{ opacity: 0 }}
            animate={{ opacity: 1 }}
            transition={{ duration: 1 }}
          >
            {menuItems.map((item, index) => (
              <Box
                key={index}
                sx={{
                  padding: '10px',
                  flexShrink: 0, // Prevent items from shrinking
                }}
              >
                <span
                  onClick={() => setActiveItem(item)}
                  style={{
                    fontSize: 20,
                    color: activeItem === item ? 'white' : 'black',
                    fontWeight: 'bold',
                    borderBottom:
                      activeItem === item
                        ? '2px solid #ffb703'
                        : '2px solid transparent',
                    padding: '9px',
                    cursor: 'pointer',
                    transition: 'all 0.3s ease-in-out',
                    background: 'linear-gradient(to right, #2D0B5A, #C106A3)',
                    borderRadius: '10px',
                  }}
                >
                  {item}
                </span>
              </Box>
            ))}
          </motion.div>

          <br />
          <br />
          {activeItemData.map((data, index) => {
            return (
              <InViewSection key={index}>
                <Box
                  style={{
                    background: 'white',
                    padding: matches ? 30 : 60,
                    marginTop: 20,
                    borderRadius: 10,
                    boxShadow: '0 4px 12px rgba(0,0,0,0.1)',
                  }}
                >
                  <Grid container spacing={6}>
                    <Grid item xs={12} lg={6}>
                      <Box>
                        <Box display={'flex'}>
                          {data.smallImag ? (
                            <img
                              src={data.smallImag}
                              style={{ borderRadius: 5, width: 70, height: 70 }}
                            />
                          ) : (
                            ''
                          )}
                          <Box ml={2}>
                            <motion.p
                              style={{
                                fontWeight: 'bold',
                                fontSize: '30px',
                                padding: '0',
                                margin: '0',
                              }}
                              initial={{ opacity: 0, x: -50 }}
                              animate={{ opacity: 1, x: 0 }}
                              transition={{ duration: 1 }}
                            >
                              {data.title}
                            </motion.p>
                            <motion.p
                              style={{ marginTop: 5, fontWeight: 'bold' }}
                              initial={{ opacity: 0, x: -50 }}
                              animate={{ opacity: 1, x: 0 }}
                              transition={{ duration: 1, delay: 0.2 }}
                            >
                              {data.subTitle}
                            </motion.p>
                          </Box>
                        </Box>
                        <Box>
                          <p>{data.desc}</p>
                        </Box>
                        {data.techImg && (
                          <Box>
                            <p style={{ fontWeight: 'bold' }}>Technology</p>
                            <Box display={'flex'} mt={2}>
                              {data.techImg &&
                                data.techImg.map((tImage) => (
                                  <img src={tImage.image} />
                                ))}
                            </Box>
                          </Box>
                        )}
                        <Box
                          mt={3}
                          style={{
                            background:
                              'linear-gradient(-89deg, #E6735E, #F25F36 28%, #DB1A88 82%, #FF0091)',
                            padding: 20,
                            width: matches ? '' : '50%',
                            textAlign: 'center',
                            color: 'white',
                            borderRadius: 50,
                            fontWeight: 'bold',
                            fontSize: 16,
                            cursor: 'pointer',
                          }}
                        >
                          <a
                            style={{ textDecoration: 'none', color: 'white' }}
                            href={data.link}
                            target="_blank"
                            rel="noopener noreferrer"
                          >
                            View Case Study
                          </a>
                        </Box>
                      </Box>
                    </Grid>
                    <Grid item xs={12} lg={6}>
                      <img
                        src={data.image}
                        style={{
                          borderRadius: 10,
                          marginTop: matches ? 20 : '',
                          height: { xs: '304px', md: '400px', lg: '400px' },
                        }}
                        alt="Universal Monsters"
                      />
                    </Grid>
                  </Grid>
                </Box>
              </InViewSection>
            );
          })}
        </Container>
      </Box>
    </>
  );
};

// Helper component to handle section visibility and animations
const InViewSection = ({ children }) => {
  const { ref, inView } = useInView({
    triggerOnce: true,
    threshold: 0.5, // Trigger when 50% of the section is visible
  });

  return (
    <motion.div
      ref={ref}
      initial={{ opacity: 0, y: 50 }}
      animate={{ opacity: inView ? 1 : 0, y: inView ? 0 : 50 }}
      transition={{ duration: 1 }}
    >
      {children}
    </motion.div>
  );
};

export default OurPortfolio;